import {isRTL} from '../../../../Localization';
import {
    DD_EXTRA_HEIGHT,
    DD_FOOTER_HEIGHT,
    DD_HEADER_HEIGHT,
    DD_RESULTS_MAX_HEIGHT,
    DD_RESULTS_MIN_HEIGHT,
    DD_TOP_OFFSET,
    ONE_COLUMN_WIDTH,
    PAGE_BOTTOM_OFFSET,
    PAGE_TOP_OFFSET,
    SEARCHABLE_WIDTH,
    TWO_COLUMN_WIDTH
} from '../constants';

function getWidth({isSearchable, title2}) {
    return isSearchable ? SEARCHABLE_WIDTH : title2 ? TWO_COLUMN_WIDTH : ONE_COLUMN_WIDTH;
}

function getElementsHeight({isSearchable, title2, searchByTitle, isMulti}) {
    return (
        DD_TOP_OFFSET +
        (isSearchable ? DD_EXTRA_HEIGHT : 0) +
        (searchByTitle || title2 ? DD_HEADER_HEIGHT : 0) +
        (isMulti ? DD_FOOTER_HEIGHT : 0)
    );
}

export function getStyle(element, windowRelative, withInput, props) {
    // height and vertical position
    let top;
    let bottom;
    const ddElementsHeight = getElementsHeight(props);
    const isUpword = getIsUpword(
        element,
        DD_RESULTS_MIN_HEIGHT,
        PAGE_BOTTOM_OFFSET,
        ddElementsHeight
    );
    if (isUpword) {
        if (windowRelative) {
            bottom = withInput
                ? window.innerHeight - element.bottom
                : window.innerHeight - element.top;
        } else {
            bottom = withInput ? 0 : element.bottom - element.top;
        }

        top = 'auto';
    } else {
        if (windowRelative) {
            top = withInput ? element.top : element.bottom;
        } else {
            top = withInput ? 0 : element.bottom - element.top;
        }
        bottom = 'auto';
    }

    const resultsAutoMaxHeight = getDropdownMaxHeight(
        element,
        DD_RESULTS_MAX_HEIGHT,
        DD_RESULTS_MIN_HEIGHT,
        PAGE_BOTTOM_OFFSET,
        ddElementsHeight
    );

    // width and horizontal position
    const width = Math.max(getWidth(props), element.right - element.left);

    let left;
    let right;

    if (windowRelative) {
        if (isRTL()) {
            left = element.right - width;
            if (left < 0) {
                left = element.left;
            }
        } else {
            left = element.left;
            if (left + width > window.innerWidth) {
                left = element.right - width;
            }
        }
    } else {
        if (isRTL()) {
            element.right - width > 0 ? (right = 0) : (left = 0);
        } else {
            element.left + width < window.innerWidth ? (left = 0) : (right = 0);
        }
    }

    return {top, bottom, left, width, right, resultsAutoMaxHeight};
}

export function getDropdownMaxHeight(
    element,
    defaultMaxHeight,
    defaultMinHeight,
    pageBottomOffset,
    ddElementsHeight
) {
    let resultsAutoMaxHeight: number;

    const isUpword = getIsUpword(element, defaultMinHeight, pageBottomOffset, ddElementsHeight);

    const availableBottomSpace = getAvailableBottomSpace(element, pageBottomOffset);
    const availableTopSpace = getAvailableTopSpace(element);

    if (isUpword) {
        resultsAutoMaxHeight = Math.min(defaultMinHeight, availableTopSpace - ddElementsHeight);
    } else {
        resultsAutoMaxHeight = Math.min(defaultMaxHeight, availableBottomSpace - ddElementsHeight);
    }
    return resultsAutoMaxHeight;
}

function getIsUpword(element, resultsMinHeight, pageBottomOffset, ddElementsHeight) {
    // if there is not enough space on the bottom
    // and there's more place on top -
    // should open on top

    const availableBottomSpace = getAvailableBottomSpace(element, pageBottomOffset);
    const availableTopSpace = getAvailableTopSpace(element);

    return (
        availableBottomSpace < ddElementsHeight + resultsMinHeight &&
        availableTopSpace > availableBottomSpace
    );
}

function getAvailableBottomSpace(element, pageBottomOffset) {
    return window.innerHeight - pageBottomOffset - element.bottom;
}

function getAvailableTopSpace(element) {
    return element.top - PAGE_TOP_OFFSET;
}
